<div class="chat-wrapper" [class.open]="isOpen" *ngIf="isOpen">
    <div class="chat-backdrop" (click)="closeChat()"></div>

    <div class="chat-panel">
        <!-- Header -->
        <div class="chat-header">
            <div class="header-info">
                <span class="header-avatar">🌍</span>
                <div>
                    <div class="header-name">{{ being['name'] }}</div>
                    <div class="header-status">
                        <span class="status-dot"></span> Online
                    </div>
                </div>
            </div>
            <button class="header-close" (click)="closeChat()" aria-label="Close chat">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                    <path d="M18 6L6 18M6 6l12 12" />
                </svg>
            </button>
        </div>

        <!-- Messages -->
        <div class="messages" #messagesContainer>
            <div *ngFor="let msg of messages$ | async" class="message" [class.from-being]="msg.senderId === being.id"
                [class.from-user]="msg.senderId !== being.id">

                <!-- GAP — the being didn't understand -->
                <ng-container *ngIf="msg.kind === 'gap'">
                    <div class="message-gap">
                        <p>{{ being['name'] }} doesn't know what to say to "{{ msg.prompt }}".</p>
                        <button *ngIf="teachingId !== msg.id" (click)="openTeach(msg)">Teach it</button>
                    </div>

                    <div class="teach-form" *ngIf="teachingId === msg.id">
                        <label>
                            Reply it should give
                            <input type="text" [(ngModel)]="teachReply" maxlength="120"
                                placeholder="i'm fine, how are you?" (keyup.enter)="submitReply()">
                        </label>

                        <label>Category</label>
                        <div class="categories">
                            <button *ngFor="let c of categories" [class.on]="teachCategory === c"
                                (click)="teachCategory = (teachCategory === c ? '' : c)">{{ c }}</button>
                            <button class="new" [class.on]="creatingCategory"
                                (click)="creatingCategory = !creatingCategory; teachCategory = ''">+ new</button>
                        </div>

                        <input *ngIf="creatingCategory" type="text" [(ngModel)]="teachCategory"
                            placeholder="name this kind of thing" maxlength="30">


                        <div class="teach-actions">
                            <button class="send" [disabled]="!teachReply.trim() || loading"
                                (click)="submitReply()">Teach the reply</button>
                            <button class="link" (click)="cancelTeach()">cancel</button>
                        </div>



                        <p class="or">or let it answer from what it senses</p>
                        <div class="readouts">
                            <button *ngFor="let r of readouts" (click)="bindReadout(r.key)" [disabled]="loading">
                                {{ r.label }}
                            </button>
                        </div>
                    </div>
                </ng-container>

                <!-- LEARNED — mirrored back on acquisition -->
                <div class="message-bubble learned" *ngIf="msg.kind === 'learned'">
                    <p>{{ msg.text }}</p>
                    <small>learned</small>
                </div>

                <!-- NORMAL -->
                <div class="message-bubble"
                    *ngIf="msg.kind !== 'gap' && msg.kind !== 'learned' && msg.kind !== 'teach' && msg.kind !== 'grade'">
                    <strong>{{ msg.senderName }}</strong>
                    <p>{{ msg.text }}</p>
                    <small>{{ msg.timestamp | date: 'HH:mm' }}</small>

                    <span class="grade" *ngIf="msg.kind === 'reply' && msg.source !== 'readout'">
                        <button (click)="gradeReply(msg, true)" aria-label="Good reply">👍</button>
                        <button (click)="gradeReply(msg, false)" aria-label="Bad reply">👎</button>
                    </span>
                </div>
            </div>

            <div class="typing-indicator" *ngIf="awaitingReply">
                <span></span><span></span><span></span>
            </div>
        </div>

        <!-- Input -->
        <div class="input-area">
            <input type="text" [(ngModel)]="newMessage" (keyup.enter)="sendMessage()" placeholder="Say something..."
                [disabled]="loading" #messageInput>
            <button (click)="sendMessage()" [disabled]="loading || !newMessage.trim()">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                    <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" />
                </svg>
            </button>
        </div>
    </div>
</div>